import React, { Component } from "react";
import Slider from "react-slick";
import imgleft from "../Assets/homepage1.png";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useTheme, useMediaQuery, Box } from "@mui/material";

function SampleNextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <ArrowForwardIosIcon className={className} style={{ ...style, display: "block" }}
    onClick={onClick} color="primary" sx={{color: "black", "&:hover": {color: "black"}}}/>
  );
}

function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <ArrowBackIosIcon
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
      color="primary"
      sx={{ color: "black", "&:hover": { color: "black" } }}
    />
  );
}

interface SimpleSliderProps {
  image_slider_urls: string[];
}

export default function SimpleSlider({ image_slider_urls }: SimpleSliderProps) {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md")); // Matches screens >= 'md'
  // const centerPadding = isMdUp ? "" : "0px"; // Set padding dynamically based on screen size

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    // centerPadding: centerPadding,
    speed: 500,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };


  return (
    <Box
      className="slider-container"
      sx={{
        overflow: "visible",
        height: { md: "100%", xs: "260px" },
        
        position: "relative",
        "& .slick-dots": {
          bottom: "-30px"
        },
        "& .slick-prev, & .slick-next": {
          top: "auto",
          bottom: "-30px",
          transform: "none",
          "&::before": {
            display: "none"
          }
        },
        "& .slick-prev": {
          left: "30%",
        },
        "& .slick-next": {
          right: "30%",
        },
        "& .slick-slide": {
          overflow: "hidden", 
          height: "25rem"
        }
      }}
    >
      <Slider {...settings}>
        {image_slider_urls.map((url, index) => (
          <div
            key={index}
            style={{
              width: "100%",
              height: "260px", // Set fixed height for all images
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden"
            }}
          >
            <img
              src={url}
              alt={`image ${index}`}
              style={{
                width: "40rem",
                
                objectFit: "fill",
                display: "block"
              }}
            />
          </div>
        ))}
      </Slider>
    </Box>
  );
}
